import * as Event from '../tools/Event';
import { addClass, removeClass } from '../tools/DOM';


export const init = () => {
	const labels = [...document.querySelectorAll('.inp__label--inside')];
	const ACTIVE_CLASS = 'is-active';
	const DISABLED_CLASS = 'is-disabled';

	const init = (label) => {
		const id = label.getAttribute('for');
		const input = document.querySelector(`[id='${id}']`);
		const placeholder = input.getAttribute('placeholder');

		const onChange = () => {
			const value = input.value;

			if (value === placeholder) return;

			if (value) {
				addClass(label, ACTIVE_CLASS);
			} else {
				removeClass(label, ACTIVE_CLASS);
			}
		};

		const onFocusIn = () => {
			addClass(label, ACTIVE_CLASS);
		};

		const onFocusOut = () => {
			if (input.value === '') {
				removeClass(label, ACTIVE_CLASS);
			}
		};

		const checkDisabled = () => {
			const isDisabled = input.hasAttribute('disabled');

			if (isDisabled) {
				addClass(label, DISABLED_CLASS);
			}
		};


		if (input.tagName === 'INPUT') {
			onChange();
		}

		checkDisabled();

		Event.on(input, 'change', onChange);
		Event.on(input, 'focusin', onFocusIn);
		Event.on(input, 'focusout', onFocusOut);
	};


	labels.forEach(init);
};



// WEBPACK FOOTER //
// ./src/js/components/label.js